import { render, staticRenderFns } from "./ModelForm.vue?vue&type=template&id=9d3f5ba6&"
import script from "./ModelForm.vue?vue&type=script&lang=js&"
export * from "./ModelForm.vue?vue&type=script&lang=js&"
import style0 from "./ModelForm.vue?vue&type=style&index=0&id=9d3f5ba6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports